import { JsonPipe } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { CmsService } from '@spartacus/core';
import { MediaComponent } from '@spartacus/storefront';
import { take } from 'rxjs/operators';
import { RemoveImageTitleAttrDirective } from '../../../../shared/remove-title-attr.directive';

@Component({
  selector: 'app-customer-service-banner',
  templateUrl: './customer-service-banner.component.html',
  styleUrls: ['./customer-service-banner.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [MediaComponent, RemoveImageTitleAttrDirective, JsonPipe],
})
export class CustomerServiceBannerComponent implements OnInit {
  csBannerComponentId = 'customerService-banner-component';
  csBannerCaption: any = 'test';
  csBannerMedia: any;

  constructor(private cmsService: CmsService) {}

  ngOnInit() {
    this.getCustomerServiceBannerData();
  }

  getCustomerServiceBannerData() {
    this.cmsService
      .getComponentData<any>(this.csBannerComponentId)
      .pipe(take(1))
      .subscribe((data) => {
        this.csBannerCaption = data.title;
        this.csBannerMedia = data.media;
      });
  }
}
